export const messages = {
  title: {
    id: 'contactInformation.Title',
    defaultMessage: 'Contact Information',
  },
  label: {
    homePhone: {
      id: 'contactInformation.Label.HomePhone',
      defaultMessage: 'Home Phone',
    },
    mobilePhone: {
      id: 'contactInformation.Label.MobilePhone',
      defaultMessage: 'Mobile Phone',
    },
    workPhone: {
      id: 'contactInformation.Label.WorkPhone',
      defaultMessage: 'Work Phone',
    },
    email: {
      id: 'contactInformation.Label.Email',
      defaultMessage: 'Email',
    },
    preferredContactMethod: {
      id: 'contactInformation.Label.PreferredContactMethod',
      defaultMessage: 'Preferred Contact Method',
    },
    preferredCommunicationLanguage: {
      id: 'contactInformation.Label.PreferredCommunicationLanguage',
      defaultMessage: 'Preferred Communication Language',
    },
  },
  message: {
    id: 'contactInformation.Label.LeaveMessage',
    defaultMessage: 'Messages can be left at this number',
  },
  placeholder: {
    preferredContactMethod: {
      id: 'contactInformation.PreferredContactMethod.SelectOne',
      defaultMessage: 'Select one...',
    },
    preferredCommunicationLanguage: {
      id: 'contactInformation.PreferredCommunicationLanguage.SelectOne',
      defaultMessage: 'Select one...',
    },
  },
};
